module.exports = __webpack_public_path__ + "static/media/logoSmall.6ed912f5.png";